module.exports = __webpack_public_path__ + "img/pic_shenfen.90b4c7b3.png";